/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import type { SyntheticEvent } from 'react';

/**
 * Construit un handler `onChange` pour les champs « heure »/« minute » à plat
 * (`name` contenant `heure` ou non), qui filtre les caractères non numériques
 * et borne la valeur (23 pour une heure, 59 pour une minute).
 *
 * Extrait de `InformationsActe` (dupliqué à l'identique dans `EtatCivil` de la
 * lib) pour être réutilisé par `InformationsEvenementReconnaissance` sans copier/coller.
 *
 * @param onChange Callback `onChange` générique du formulaire (name/value).
 */
const createTimeInputHandler =
  (
    onChange: (
      event: SyntheticEvent | null,
      payload: { name: string; value: unknown },
    ) => void,
  ) =>
  (
    e: SyntheticEvent | null,
    { name, value }: { name: string; value: string },
  ) => {
    const number = value.replace(/[^0-9]/g, '');
    if (number === '') {
      onChange(e, { name, value: null });
      return;
    }
    const numValue = parseInt(number, 10);
    // Insensible à la casse : `naissanceHeure` doit être borné comme `heure`.
    if (numValue > (name.toLowerCase().includes('heure') ? 23 : 59)) {
      return;
    }
    onChange(e, { name, value: numValue });
  };

export default createTimeInputHandler;
